function cleanInvalidAria() {
  document.querySelectorAll('.gallery-cell, .testimonial-block').forEach(el => {
    if (el.hasAttribute('aria-selected')) {
      el.removeAttribute('aria-selected');
    }
    if (el.hasAttribute('aria-current')) {
      el.removeAttribute('aria-current');
    }
  });
}

// Run once
cleanInvalidAria();

// Watch for Flickity changes
const observer = new MutationObserver(() => {
  cleanInvalidAria();
});

observer.observe(document.body, {
  attributes: true,
  subtree: true,
  attributeFilter: ['aria-selected', 'aria-current']
});


window.addEventListener('load', () => {
  const iframe = document.querySelector('#PBarNextFrame');
  if (iframe && !iframe.hasAttribute('title')) {
    iframe.setAttribute('title', 'Shopify Preview Bar');
  }
});